import React,{ useState, useEffect } from "react"
import axios from "axios"
import Select from "react-select"
import jwt_decode from "jwt-decode"
import { useParams, useNavigate, Link } from "react-router-dom"
import Clock from 'react-clock';
import 'react-clock/dist/Clock.css';
import baseURL from "../Url/Url.jsx";
import SideBar from "../Layout/SideBar.jsx";
import PilihPeriode from "../Layout/PilihPeriode.jsx";

const MenuDashboard = () => {
    // variabel sistem utama
    const [userName, setUserName] = useState("")
    const [perusahaan, setPerusahaan] = useState("")
    const [estateList, setEstateList] = useState([]);
    const [estate, setEstate] = useState("")
    const [bulan, setBulan] = useState("Bulan")
    const [tahun, setTahun] = useState("Tahun")
    const [karyawanTetap, setKaryawanTetap] = useState([])
    const [karyawanTidakTetap, setKaryawanTidakTetap] = useState([])
    const [allPerhitunganTetap, setAllPerhitunganTetap] = useState([])
    const [allPerhitunganTidakTetap, setAllPerhitunganTidakTetap] = useState([])
    const [, setToken] = useState("")
    const [expire, setExpire] = useState("")
    const navigate = useNavigate()
    const { perusahaanParams } = useParams()
    const { bulanParams } = useParams()
    const { tahunParams } = useParams()
    const [time, setTime] = useState(new Date());

    // Sistem utama
    useEffect(()=>{
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
        backdrop.remove();
        }
        document.body.removeAttribute("data-new-gr-c-s-check-loaded");
        document.body.removeAttribute("data-gr-ext-installed");
        document.body.removeAttribute("data-gr-ext-disabled");
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto"; // Atau sesuaikan jika ada efek lain yang perlu dipertahankan
        document.body.style.paddingRight = "0px"; // Sesuaikan jika perlu
        refreshToken()
        selectKaryawanTetap()
        selectKaryawanTidakTetap()
        selectAllPerhitunganTetap()
        selectAllPerhitunganTidakTetap()
        const intervalID = setInterval(() => {setTime(new Date())}, 1000)
        return () => clearInterval(intervalID);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    
    }, [perusahaan, bulan, tahun]);

    useEffect(() => {
        const savedOption = localStorage.getItem("selectedOption");
        if (savedOption) {
            const [savedPerusahaan, savedEstate] = savedOption.split("|");
            setPerusahaan(savedPerusahaan);
            setEstate(savedEstate);
        }
    }, []);

    // Refresh token
    const refreshToken = async() => {
        try {
            const response = await axios.get(`${baseURL}/tokenBE`)
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setUserName(decoded.userName)
            // cek cache dulu
            const savedOption = localStorage.getItem("selectedOption");
            if (savedOption) {
                const [savedPerusahaan, savedEstate] = savedOption.split("|");
                setPerusahaan(savedPerusahaan);
                setEstate(savedEstate);
            } else {
                setPerusahaan(decoded.perusahaan);
                setEstate(decoded.status);
            }
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)

            getEstateList(decoded.userName)
        } catch (error) {
            if(error.response){
                navigate("/", { replace: true })
            }   
        }
    }

    const axiosJWT = axios.create()
    axiosJWT.interceptors.request.use(async(config) => {
        const currentDate = new Date()
        if(expire * 1000 < currentDate.getTime()){
            const response = await axios.get(`${baseURL}/tokenBE`)
            config.headers.Authorization = `Bearer ${response.data.accessToken}`
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        }
        return config
    }, (error)=>{
        return Promise.reject(error)
    })

    // Logout
    const Logout = async() =>{
        try {
            await axios.delete(`${baseURL}/logoutBE`)
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error)
        }
    }

    // Ambil daftar perusahaan + estate berdasarkan username
    const getEstateList = async (username) => {
        try {
            const response = await axios.post(
                `${baseURL}/selectPerusahaanByUserNameBE`,
                { userName: username }
            )
            setEstateList(response.data)
        } catch (error) {
            console.log("Gagal mengambil estate list:", error.response?.data || error.message)
            setEstateList([])
        }
    }
    const estateOptionsWithAll = [
        { value: `${perusahaan}|ALL`, label: "All" }, // Semua estate untuk perusahaan saat ini
        ...estateList.map((item) => ({
            value: `${item.perusahaan}|${item.status}`,
            label: `${item.status} | ${item.perusahaan}`
        }))
    ];
    
    // Menampilkan semua perhitungan tetap
    const selectAllPerhitunganTetap = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectAllPerhitunganTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}`)
            setAllPerhitunganTetap(response.data)
        }catch(error){
            console.log(error)
        }
    }

    // Menampilkan semua perhitungan tidak tetap
    const selectAllPerhitunganTidakTetap = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectAllPerhitunganTidakTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}`)
            setAllPerhitunganTidakTetap(response.data)
        }catch(error){
            console.log(error)
        }
    }

    // Menampilkan karyawan tetap
    const selectKaryawanTetap = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectPerhitunganTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}`)
            setKaryawanTetap(response.data)
        }catch(error){
            console.log(error)
        }
    }

    
    const filteredDataTetap = karyawanTetap.filter((item) => {
        // Filter estate
        const matchPerusahaan = item.perusahaan?.toLowerCase() === perusahaan.toLowerCase();
        const matchEstate = estate === "ALL"
            ? estateList.some(
                (e) =>
                    e.perusahaan?.toLowerCase() === perusahaan.toLowerCase() &&
                    e.status?.toLowerCase() === item.unitKerja?.toLowerCase()
            )
            : item.unitKerja?.toLowerCase() === estate.toLowerCase();
        return matchEstate && matchPerusahaan;
    })

    // menghitung jumlah karyawan tetap
    const countDataKaryawanTetap = () => {
        const count = filteredDataTetap.reduce((acc, item) => {
          if (item.ktp) {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }

    // menampilkan karyawan tidak tetap
    const selectKaryawanTidakTetap = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectPerhitunganTidakTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}`)
            setKaryawanTidakTetap(response.data)
        }catch(error){
            console.log(error)
        }
    }

    const filteredDataTidakTetap = karyawanTidakTetap.filter((item) => {
        // Filter estate
        const matchPerusahaan = item.perusahaan?.toLowerCase() === perusahaan.toLowerCase();
        const matchEstate = estate === "ALL"
            ? estateList.some(
                (e) =>
                    e.perusahaan?.toLowerCase() === perusahaan.toLowerCase() &&
                    e.status?.toLowerCase() === item.unitKerja?.toLowerCase()
            )
            : item.unitKerja?.toLowerCase() === estate.toLowerCase();
        return matchEstate && matchPerusahaan;
    })

    // menghitung jumlah karyawan tidak tetap
    const countDataKaryawanTidakTetap = () => {
        const count = filteredDataTidakTetap.reduce((acc, item) => {
          if (item.ktp) {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }

    const filteredDataAllPTetap = allPerhitunganTetap.filter((item) => {
        // Filter estate
        const matchPerusahaan = item.perusahaan?.toLowerCase() === perusahaan.toLowerCase();
        const matchEstate = estate === "ALL"
            ? estateList.some(
                (e) =>
                    e.perusahaan?.toLowerCase() === perusahaan.toLowerCase() &&
                    e.status?.toLowerCase() === item.unitKerja?.toLowerCase()
            )
            : item.unitKerja?.toLowerCase() === estate.toLowerCase();
        return matchEstate && matchPerusahaan;
    })
    
    const filteredDataAllPTidakTetap = allPerhitunganTidakTetap.filter((item) => {
        // Filter estate
        const matchPerusahaan = item.perusahaan?.toLowerCase() === perusahaan.toLowerCase();
        const matchEstate = estate === "ALL"
            ? estateList.some(
                (e) =>
                    e.perusahaan?.toLowerCase() === perusahaan.toLowerCase() &&
                    e.status?.toLowerCase() === item.unitKerja?.toLowerCase()
            )
            : item.unitKerja?.toLowerCase() === estate.toLowerCase();
        return matchEstate && matchPerusahaan;
    })
    
    // menghitung jumlah data perhitungan tetap pada bulan januari
    const countDataJan = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "JANUARI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan februari
    const countDataFeb = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "FEBRUARI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan maret
    const countDataMar = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "MARET") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan april
    const countDataApr = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "APRIL") {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan mei
    const countDataMei = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "MEI") {
                return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan juni
    const countDataJun = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "JUNI") {
                return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan juli
    const countDataJul = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "JULI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan agustus
    const countDataAgs = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "AGUSTUS") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan september
    const countDataSep = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "SEPTEMBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan oktober
    const countDataOkt = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "OKTOBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan november
    const countDataNov = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "NOVEMBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tetap pada bulan desember
    const countDataDes = () => {
        const count = filteredDataAllPTetap.reduce((acc, item) => {
            if (item.bulan === "DESEMBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan januari
    const countDataTJan = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "JANUARI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan februari
    const countDataTFeb = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "FEBRUARI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan maret
    const countDataTMar = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "MARET") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan april
    const countDataTApr = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "APRIL") {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan mei
    const countDataTMei = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "MEI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan juni
    const countDataTJun = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "JUNI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan juli
    const countDataTJul = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "JULI") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan agustus
    const countDataTAgs = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "AGUSTUS") {
                return acc + 1;
            }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan september
    const countDataTSep = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "SEPTEMBER") {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan oktober
    const countDataTOkt = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "OKTOBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan november
    const countDataTNov = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
            if (item.bulan === "NOVEMBER") {
                return acc + 1;
            }
            return acc;
        }, 0);
        return count;
    }
    // menghitung jumlah data perhitungan tidak tetap pada bulan desember
    const countDataTDes = () => {
        const count = filteredDataAllPTidakTetap.reduce((acc, item) => {
          if (item.bulan === "DESEMBER") {
            return acc + 1;
          }
          return acc;
        }, 0);
        return count;
    }
    
    // Halaman
    return (
        <div id="wrapper">

            {/* SIDE BAR */}
            <SideBar 
                bulanParams={bulan}
                tahunParams={tahun}
                perusahaanParams={perusahaan}
                tahunSekarang={tahun}
            />
            
            {/* KONTEN WRAP */}
            <div id="content-wrapper">

                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <div className="dropdown ml-2">
                            <button className="navbar-toggler mb-2" data-bs-toggle="collapse" data-bs-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation" style={{border:"none"}}>
                                <i className="bi bi-grid-fill" style={{fontSize:"22px"}}></i>
                            </button>
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        <div className="d-flex" role="search">
                            <Select
                                className="form-control form text-center mx-2"
                                value={estateOptionsWithAll.find(
                                    (opt) => opt.value === `${perusahaan}|${estate}`
                                )}
                                onChange={(selectedOption) => {
                                    const [selectedPerusahaan, selectedEstate] = selectedOption.value.split("|")
                                    setPerusahaan(selectedPerusahaan)
                                    setEstate(selectedEstate)
                                    // Simpan ke cache
                                    localStorage.setItem("selectedOption", selectedOption.value);
                                    
                                    // Reload halaman dengan params
                                    navigate(`/menu-dashboard/${selectedPerusahaan}/${bulan}/${tahun}`)
                                }}
                                options={estateOptionsWithAll}
                                isSearchable
                                styles={{
                                    container: (base) => ({
                                        ...base,
                                        marginTop: "-2px",
                                        maxWidth: "140px",
                                        fontWeight: "700",
                                        fontSize: "10pt",
                                        color:"rgb(108, 108, 108)",
                                        boxShadow: "none",  
                                        height: "auto",
                                        padding:"0",
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        borderRadius:"30px",
                                        border:"none",
                                        background:"transparant",
                                        height: "10px",
                                        color:"rgb(108, 108, 108)",
                                        boxShadow: "none",  
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        width: "300px", // agar dropdown menyesuaikan lebar control
                                    })
                                }}
                            />
                            <input type="text" className="form-control form" value={perusahaan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"300px"}} readOnly/>
                            <input type="text" className="form-control form mx-2" value={bulan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"120px",textAlign:"center"}} readOnly/>
                            <input type="text" className="form-control form" value={tahun} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"70px",textAlign:"center"}} readOnly/>
                            <button onClick={Logout} className="btn btn-logout mx-2"><i className="bi bi-power" style={{color:"white",fontSize:"22px"}}></i></button>
                        </div>
                    </div>
                </nav>

                {/* KONTEN */}
                {bulan === "JANUARI" || bulan === "FEBRUARI" || bulan === "MARET"|| bulan === "APRIL"|| bulan === "MEI"|| bulan === "JUNI"|| bulan === "JULI"|| bulan === "AGUSTUS"|| bulan === "SEPTEMBER"|| bulan === "OKTOBER"|| bulan === "NOVEMBER"|| bulan === "DESEMBER"          
                ?<div>
                    <div className="container-fluid" style={{overflow:"auto",display:"block",width:"100%",height:"88vh"}}>
                        <h4 className="text-center mt-4 mb-3" style={{fontWeight:"700"}}>Selamat Datang di Mantap Payroll</h4>
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-6 mt-3">
                                <div className="box pt-4 pb-4 px-3" style={{width: "100%",minHeight:"136px",overflow:"auto"}}>
                                    <h6 className="text-center" style={{fontWeight:"700"}}>Cek Perhitungan PPH.21 Karyawan Tetap</h6>
                                    <table style={{width:"100%"}}>
                                        <tr>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jan</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Feb</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Mar</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Apr</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Mei</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jun</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jul</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Ags</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Sep</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Okt</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Nov</td>
                                            <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Des</td>
                                        </tr>
                                        <tr>
                                            <td>{countDataJan()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataFeb()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataMar()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataApr()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataMei()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataJun()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataJul()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataAgs()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataSep()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataOkt()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataNov()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            <td>{countDataDes()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                        </tr>
                                        <tr>
                                            <td><div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div></td>
                                            <td colSpan="11"><h6 style={{fontWeight:"400",textAlign:"left",paddingTop:"7px"}}>PPH.21 Sudah Dihitung</h6></td>
                                        </tr>
                                        <tr>
                                            <td><div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)",marginTop:"-13px"}}></div></td>
                                            <td colSpan="11"><h6 style={{fontWeight:"400",textAlign:"left",marginTop:"-7px"}}>PPH.21 Belum Dihitung</h6></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 mt-3">
                                <div className="box pt-4 pb-4 px-3" style={{width: "100%",minHeight:"136px",overflow:"auto"}}>
                                    <h6 className="text-center" style={{fontWeight:"700"}}>Cek Perhitungan PPH.21 Karyawan Tidak Tetap</h6>
                                    <table style={{width:"100%"}}>
                                        <thead>
                                            <tr>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jan</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Feb</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Mar</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Apr</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Mei</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jun</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Jul</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Ags</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Sep</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Okt</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Nov</td>
                                                <td style={{width:"8.3%",color:"rgb(108, 108, 108)",fontWeight:"400"}}>Des</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{countDataTJan()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTFeb()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTMar()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTApr()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTMei()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTJun()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTJul()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTAgs()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTSep()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTOkt()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTNov()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                                <td>{countDataTDes()>0?<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div>:<div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)"}}></div>}</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <td><div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(108, 255, 100)"}}></div></td>
                                                <td colSpan="11"><h6 style={{fontWeight:"400",textAlign:"left",paddingTop:"7px"}}>PPH.21 Sudah Dihitung</h6></td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <td><div className="mx-auto d-block text-center" style={{height:"13px",width:"13px",borderRadius:"50%",backgroundColor:"rgb(255, 100, 100)",marginTop:"-13px"}}></div></td>
                                                <td colSpan="11"><h6 style={{fontWeight:"400",textAlign:"left",marginTop:"-7px"}}>PPH.21 Belum Dihitung</h6></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12 col-md-6 col-lg-6 mt-4">
                                <div className="box py-2 px-5 mb-4" style={{width: "100%",minHeight:"136px"}}>
                                    <div className="row">
                                        <div className="col-12 col-lg-6 mt-2">
                                            <h6 className="text-center" style={{fontWeight:"700"}}>Jumlah</h6>
                                                <h1 className="text-center" style={{fontWeight:"700"}}><i className="bi bi-people" style={{color:"rgb(0, 191, 198)"}}></i> {countDataKaryawanTetap()}</h1>
                                            <h6 className="text-center" style={{fontWeight:"700"}}>Karyawan Tetap</h6>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-2">
                                            <h6 className="text-center" style={{fontWeight:"700"}}>Jumlah</h6>
                                                <h1 className="text-center" style={{fontWeight:"700"}}><i className="bi bi-people" style={{color:"rgb(0, 191, 198)"}}></i> {countDataKaryawanTidakTetap()}</h1>
                                            <h6 className="text-center" style={{fontWeight:"700"}}>Karyawan Tidak Tetap</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="box p-3" style={{width: "100%",minHeight:"92px"}}>
                                    { bulan === ""
                                    ?<div>
                                        <h6 className="text-center" style={{fontWeight:"700"}}>Periode Masih Kosong, Pilih Periode</h6>
                                        <button className="btn btn-login mx-auto d-block" data-bs-toggle="modal" data-bs-target="#staticBackdropPilihPeriode" style={{border:"none",backgroundColor:"white",marginTop:"-3px"}}><i className="bi bi-calendar4-week"></i><span> Pilih Periode</span></button>
                                    </div>
                                    :<div>
                                        <h6 className="text-center" style={{fontWeight:"700"}}>Periode Sekarang {bulan} {tahun}</h6>
                                        <button className="btn btn-login mx-auto d-block" data-bs-toggle="modal" data-bs-target="#staticBackdropPilihPeriode" style={{border:"none",backgroundColor:"white",marginTop:"-3px"}}><i className="bi bi-calendar4-week"></i><span> Pilih Periode</span></button>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mt-4">
                                <div className="box px-4 py-3" style={{width: "100%",minHeight:"248px"}}>
                                    <h6 className="text-center mb-3" style={{fontWeight:"700"}}>Cetak Laporan</h6>
                                    <Link to={`/menu-laporan-slip/${perusahaan}/${bulan}/${tahun}`} className="btn p-1 mb-3" style={{width:"100%",border:"1px solid rgb(108,108,108)",borderRadius:"20px"}}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i> Laporan Slip</Link>
                                    <Link to={`/menu-laporan-gaji/${perusahaan}/${bulan}/${tahun}`} className="btn p-1 mb-3" style={{width:"100%",border:"1px solid rgb(108,108,108)",borderRadius:"20px"}}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i> Laporan Gaji</Link>
                                    <Link to={`/menu-laporan-pph/${perusahaan}/${bulan}/${tahun}`} className="btn p-1 mb-3" style={{width:"100%",border:"1px solid rgb(108,108,108)",borderRadius:"20px"}}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i> Laporan PPH</Link>
                                    <Link to={`/menu-laporan-coretax/${perusahaan}/${bulan}/${tahun}`} className="btn p-1 mb-1" style={{width:"100%",border:"1px solid rgb(108,108,108)",borderRadius:"20px"}}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i> Laporan CoreTax</Link>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mt-4">
                                <div className="box p-4" style={{width: "100%",minHeight:"248px"}}>
                                    <Clock className="mx-auto d-block" value={time}size={200}renderNumbers={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                :<div>

                    {/* Pilih Periode */}
                    <PilihPeriode
                        bulan={bulan}
                        perusahaan={perusahaan}
                        tahunSekarang={tahun}
                    />
                    
                </div>
            }

            </div>
        </div>
    )
}

export default MenuDashboard